import script from "./FormInvoiceSubmission.vue?vue&type=script&setup=true&lang=js"
export * from "./FormInvoiceSubmission.vue?vue&type=script&setup=true&lang=js"

import "./FormInvoiceSubmission.vue?vue&type=style&index=0&id=043fb978&lang=css"

const __exports__ = script;

export default __exports__